// src/main.tsx
// Bootstrap do navegador: QueryClient + Router. Só providers aqui.
import "./lib/crypto-polyfill"; // randomUUID em HTTP de LAN (secure-context) — deve vir 1º
import { readStoredBrand } from "@/lib/brand-cache";
import { organizationTheme } from "@/lib/branding-theme";
import { usePreferencesStore } from "@/preferences-store";
import { applyTheme } from "@/theme";
import React, { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import { i18n } from "@/i18n";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@organizacaox/lai-design-system/router";
import "@organizacaox/lai-design-system/styles.css";
import "./index.css";
import { router } from "@/router";
import { queryClient } from "@/lib/query-client";
import { AppErrorBoundary, AppLoadingScreen } from "@/lib/app-states";
import { initializePwaInstall } from "@/pwa/install-store";
import { PwaUpdateNotice } from "@/pwa/update-notice";
import { initializePwaBranding } from "@/pwa/branding";

const initialBranding = initializePwaBranding() ?? readStoredBrand();
usePreferencesStore.getState().setOrganizationTheme(organizationTheme(initialBranding?.settings));
applyTheme(usePreferencesStore.getState().theme);
initializePwaInstall();

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <AppErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <Suspense fallback={<AppLoadingScreen />}>
              <RouterProvider router={router} />
              <PwaUpdateNotice />
            </Suspense>
          </QueryClientProvider>
        </AppErrorBoundary>
      </I18nextProvider>
    </React.StrictMode>,
  );
}
